@use "src/theme";

:global([data-modal-container-root="true"][data-visible="true"]) .dialogContent {
  animation: contentShow 180ms cubic-bezier(0.16, 1, 0.3, 1);
}

.dialogHeader {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.375rem;
}

.dialogTitle {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.5rem;
  padding-inline-end: 2.75rem;
}

.dialogDescription {
  max-width: 42rem;
  text-wrap: pretty;
}

.dialogBody {
  display: flex;
  min-height: 0;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
  // Leave room for the global 3px outline plus its 3px offset.
  margin: -0.375rem;
  padding: 0.375rem;

  @media (min-width: 768px) {
    &[data-scroll="panels"] {
      overflow: hidden;
    }
  }
}

.closeButton {
  position: absolute !important;
  top: 1rem;
  inset-inline-end: 1rem;
  z-index: 20;
  padding: 0.5rem !important;
}

@keyframes sheetShow {
  from {
    opacity: 0;
    transform: translateY(2rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes contentShow {
  from {
    opacity: 0;
    transform: translateY(0.75rem) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// A form around the body and actions lays its children out as the dialog's own.
.dialogForm {
  display: contents;
}

// Same divider and spacing as FormLayout.Actions, so every form ends the same way.
.dialogActions {
  display: flex;
  width: 100%;
  flex-flow: row nowrap;
  justify-content: flex-end;
  gap: 0.5rem;
  border-top: 1px solid var(--color-border);
  padding-top: 1rem;
}

// On phones every dialog is a bottom sheet: full width, against the bottom edge, rising into place.
@media (max-width: 639px) {
  .dialogContent {
    position: absolute;
    inset-inline: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    max-height: calc(100dvh - 0.5rem);
    border-radius: 1rem 1rem 0 0;
    padding: 1rem;
    padding-bottom: calc(1rem + env(safe-area-inset-bottom));
  }

  :global([data-modal-container-root="true"][data-visible="true"]) .dialogContent {
    animation-name: sheetShow;
  }

  .dialogActions {
    flex-direction: column-reverse;
  }

  .dialogActions > * {
    width: 100%;
  }
}
